import { PureComponent } from 'react'


import Pages from '..'
import { matchPath, withDashboardContext } from '@stackhouse/dashboard-components/Dashboard'

import Alert from '@stackhouse/dashboard-components/Alert'

import ChangePassword from '../../components/UserInfo/changePassword'
import isMobile from '../../utils/is-mobile'


const isDevelopment = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')

const mapPages = (pages) => {
    return pages.reduce((acc, page) => {
        const Page = (page.id && Pages[page.id]) ? Pages[page.id] : {}

        if (page.mobile == false && isMobile)
            return acc

        return [...acc, {
            ...Page,
            ...page,
            ...page.pages ? { pages: mapPages(page.pages) } : {},
            ...Page.pages ? { pages: mapPages(Page.pages) } : {},
        }]
    }, [])
}

const handleBeforeunload = (event) => {
    event.preventDefault()
    event.returnValue = true
}


const registerUnloadPrompt = () => {
    window.addEventListener('beforeunload', handleBeforeunload)
}


class PageHandler extends PureComponent {

    componentDidMount() {

        if (!isDevelopment) {
            registerUnloadPrompt()
        }

        const { history, setPages, setUser, user, location: { state } } = this.props
        const pages = localStorage.getItem('MENU')

        if (user) {
            const { client } = this.props

            if (+new Date() > +new Date(user.accessToken.expires)) {
                const { routes = [] } = this.props
                const login = routes.find(route => route.authentication)
                console.log('User token expired, redirecting to login page')
                return history.replace(login.path)
            }
            else {
                if (user.changePasswrordRequired || user.changePasswordRequired) {
                    ChangePassword(
                        { username: user.loginUsername, canCancel: false, title: 'Password change required' },
                        {
                            closeOnClick: false,
                            onClose: () => {
                                setUser(
                                    {
                                        ...user,
                                        changePasswrordRequired: false,
                                        changePasswordRequired: false
                                    },
                                    user.accessToken.accessToken
                                )
                            }
                        }
                    )
                }
                const callback = () => {
                    const { routes = [] } = this.props

                    if (state && state.referrer) {
                        const referrer = routes.find(route => matchPath(state.referrer, { path: route.path, exact: true }))
                        if (referrer) {
                            return history.replace(state.referrer)
                        }
                    }

                    const firstRoute = routes.find(route => !route.authentication)
                    return firstRoute && history.replace(firstRoute.path)
                }

                return client.get('/permission/menu').then(({ data: pages }) => {
                    localStorage.setItem('MENU', JSON.stringify(pages))
                    return setPages([...mapPages(pages), Pages.login, DefaultPage, Pages.filterTest], callback)
                })

            }

        }
        else {
            const { routes = [] } = this.props
            const login = routes.find(route => route.authentication)
            console.log('No user, redirecting to login page')
            return history.replace(login.path)
        }
    }

    render() {
        return null
    }
}


const DefaultPage = {
    title: 'R3TeamSmart',
    drawer: false,
    exact: true,
    default: true,
    path: '/index',
    authenticated: true,
    component: withDashboardContext(PageHandler, ({ client, routes, setPages, setUser }) => ({ client, routes, setPages, setUser })),
    // layout: {
    //     fullscreen: true
    // }
}

export default DefaultPage
